import { render, staticRenderFns } from "./EditBankHolidays.vue?vue&type=template&id=db73fed6&scoped=true"
import script from "./EditBankHolidays.vue?vue&type=script&lang=js"
export * from "./EditBankHolidays.vue?vue&type=script&lang=js"
import style0 from "./EditBankHolidays.vue?vue&type=style&index=0&id=db73fed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db73fed6",
  null
  
)

export default component.exports